import React from "react";
import Registro from "../components/Registro";

const RegistroPage = () => {
  return (
    <>

      {/* SignUpLayer */}
      <Registro />

    </>
  );
};

export default RegistroPage; 
